import { render, staticRenderFns } from "./surplus-space.vue?vue&type=template&id=d89db46c&scoped=true&"
import script from "./surplus-space.vue?vue&type=script&lang=js&"
export * from "./surplus-space.vue?vue&type=script&lang=js&"
import style0 from "./surplus-space.vue?vue&type=style&index=0&id=d89db46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89db46c",
  null
  
)

export default component.exports